
import { produce } from 'immer';
import Cookies from 'universal-cookie';
// const cookies = new Cookies();

const authReducer = (
    state = {
        loading: false,
        auth: {
            isLogged: false
        },
        passwordReset: {
            submitted: false
        },
        session: null,
        user: null,
        active_settings: 0,
        onboarding_version: null
    },
    action
) => {
    switch (action.type) {
        case 'SET_TEST_REDUCER':
            state = {
                ...state,
                test: 'TEST DONE ! ' + action.payload
            }
            break;
        case 'SET_SESSION':
            state = {
                ...state,
                session: action.payload,
                auth:{
                    isLogged: action.payload ? true : false
                }            
            }
            break;
        case 'RESET_SESSION':
            state = {
                ...state,
                session: null
            }
            break;
        case 'SET_USER':
            state = {
                ...state,
                user: action.payload,
                    auth:{
                        isLogged: true
                    }
            }
            break;
        case 'RESET_USER':
            state = {
                ...state,
                user: null
            }
            break;
        case 'UPDATE_USER':
            return produce(state, (draft) => {
                Object.assign(draft.user, action.payload);
            });
        case 'SET_AUTH_LOADING':
            state = {
                ...state,
                loading_auth: action.payload
            }
            break;
        case "SUBSCRIBE_SUCCESS": {
            return produce(state, (draft) => {
                draft.user.subscriptions = action.payload.subscribe ?
                    [...draft.user?.subscriptions || [], action.payload.user]
                    : (draft.user?.subscriptions || []).filter(user => user?.user_id !== action.payload.subscribed_to_id)
            });
        }
        case "SUBSCRIBE_SUCCESS_FROM_PROFILE": {
            return {
                ...state,
                user: {
                    ...state.user,
                    subscribers: [
                        ...(state.user?.subscribers || []).map(user => user.user_id === action.payload.subscribed_to_id ? { ...user, is_subscribed: action.payload.subscribe } : user),
                    ],
                    subscriptions: [
                        ...(state.user?.subscriptions || []).map(user => user.user_id === action.payload.subscribed_to_id ? { ...user, is_subscribed: action.payload.subscribe } : user),
                    ],
                    contributors: [
                        ...(state.user?.contributors || []).map(user => user.user_id === action.payload.subscribed_to_id ? { ...user, is_subscribed: action.payload.subscribe } : user),
                    ],
                    contributions: [
                        ...(state.user?.contributions || []).map(user => user.user_id === action.payload.subscribed_to_id ? { ...user, is_subscribed: action.payload.subscribe } : user),
                    ],
                    ...action.payload.list_used !== 'subscriptions' && {
                        subscriptions: action.payload.subscribe ?
                            [...state.user?.subscriptions || [], action.payload.user]
                            : (state.user?.subscriptions || []).filter(user => user && user.user_id !== action.payload.subscribed_to_id),
                    },
                    subscriptions_number: action.payload.subscribe ?
                        state.user?.subscriptions_number + 1 :
                        state.user?.subscriptions_number - 1
                }
            }
        }
        case "SUBSCRIBE_SUCCESS_FROM_OTHERS": {
            return {
                ...state,
                ...state.view_user && {
                    view_user: {
                        ...state.view_user,
                        [action.payload.list_used]: [
                            ...(state.view_user?.[action.payload.list_used] || []).map(user => user.user_id === action.payload.subscribed_to_id ? { ...user, is_subscribed: action.payload.subscribe } : user),
                        ]
                        //   [action.payload.list_used]: action.payload.subscribe ?
                        //     [...state.view_user?.[action.payload.list_used] || [], action.payload.user]
                        //     : (state.view_user?.[action.payload.list_used] || []).filter(user => user.user_id !== action.payload.subscriber_id)
                        // }
                    }
                },
            };
        }
        case "SET_ACTIVE_SETTINGS":
            state = {
                ...state,
                active_settings: action.payload
            }
            break;
        case 'SET_USER_ROLE':
            return produce(state, (draft) => {
                draft.user.role = action.payload
            })
            break
        case 'GET_USER_ONBOARDING_VERSION_SUCCESS':
            state = {
                ...state,
                onboarding_version: action.payload?.onboarding_version
            }
            break
        case 'GET_USER_ONBOARDING_VERSION_FAILURE':
            state = {
                ...state,
                onboarding_version: null
            }
            break
    }
    return state;
};

export default authReducer;

